import React from "react";
import { ResponsiveModal } from "@UI/Components/ResponsiveModal/ResponsiveModal";
import { Heading } from "@UI/Components/Heading/Heading";
import { Text } from "@UI/Components/Text/Text";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { Box } from "@UI/Components/Box/Box";
import { BecomeSuperTalent } from "./BecomeSuperTalentCTA";
import { useNavigate } from "@Libs/Router/hooks/useNavigate";
import messages from "./messages";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  isMobile: boolean;
}

export const JobsInProgressModal = ({ isOpen, onClose, isMobile }: Props) => {
  const navigate = useNavigate();

  const handleOnClick = () => {
    navigate(["SUPERTALENT_OBJECTIVES"]);
  };

  return (
    <ResponsiveModal
      isOpen={isOpen}
      onClose={onClose}
      isCentered={!isMobile}
      size={{ base: "sm", md: "lg" }}
    >
      <Box mb={4}>
        <Heading
          as="h3"
          marginRight="3"
          mb={2}
          fontSize={{ base: "2xl", lg: "4xl" }}
        >
          <FormattedMessage {...messages.jobsInProgress} />
        </Heading>
        <Text fontSize="md" mt={4}>
          <FormattedMessage {...messages.jobsInProgressModalInfos} />
        </Text>
        <BecomeSuperTalent onClick={handleOnClick} />
      </Box>
    </ResponsiveModal>
  );
};
